import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-white scroll-mt-[72px]">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3">
            关于8848影院，你可能想了解的一些事
          </p>
        </div>

        <div className="flex flex-col gap-4">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line text-primary-500 text-lg"></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-2">
                    {item.q}
                  </h3>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}